export enum SubServiceTypeActionType {
  FETCH_SUB_SERVICE_TYPES = "FETCH_SUB_SERVICE_TYPES",
  FETCH_SUB_SERVICE_REQUEST = "FETCH_SUB_SERVICE_REQUEST",
  FETCH_SUB_SERVICE_SUCCESS = "FETCH_SUB_SERVICE_SUCCESS",
  FETCH_SUB_SERVICE_ERROR = "FETCH_SUB_SERVICE_ERROR",
}
